import {AnimatePresence, motion} from "framer-motion";
import {FC} from "react";
import {Button} from "../../ui-components/button.tsx";
import {Heading} from "../../ui-components/heading.tsx";
import {Text} from "../../ui-components/text.tsx";
import {ModalPropsType, useModal} from "../../context/ModalContext.tsx";
import {useTranslation} from "react-i18next";

export type StopCampaignType = {
    id: number
    title: string
    isOpen: boolean

    onClose: () => void
}

export const StopCampaignModal: FC<ModalPropsType> = ({isOpen, onClose, modalId, title, desc, stopCampaignType}) => {
    const {closeModal} = useModal();

    const handleJustClose = () => {
        if (modalId) {
            closeModal(modalId);
        }
    };
    const handleSubmitAndClose = () => {
        onClose();
    };
    const {t} = useTranslation()
    return (
        <AnimatePresence>
            {isOpen && (
                <div className="absolute inset-0 bg-black/50 flex items-end justify-center z-[999999]"
                     onClick={handleJustClose}>
                    <motion.div
                        initial={{y: "100%", opacity: 0}}
                        animate={{y: 0, opacity: 1}}
                        exit={{y: "100vh", opacity: 0}}
                        transition={{duration: 0.4, ease: "easeInOut"}}
                        className="bg-white rounded-t-xl w-full px-4.5 pt-6 pb-8 shadow-lg flex flex-col items-center"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Heading level={2} className={"text-2xl text-center font-medium"}>
                            {title}
                        </Heading>
                        <Text className={'!text-sm text-[var(--color-secondary-2)]  text-center mt-4 opacity-60'}>
                            {desc}
                        </Text>
                        <div className={"flex  gap-6 w-full mt-6"}>
                            <Button color={"white"}
                                    onClick={handleJustClose}
                                    className={"!text-sm !font-semibold !text-black py-[10px] w-full rounded-lg box-shadow overflow-hidden !bg-white !border !border-[var(--btn-border-custom)]"}>
                                {t('common.buttons.cancel')}
                            </Button>
                            <Button color={"dark/white"}
                                    onClick={handleSubmitAndClose}
                                    className={"w-full flex items-center rounded-lg !text-sm !py-2.5 !text-white bg-[var(--background-btn-dark)]"}>
                                {stopCampaignType === 'stop'
                                    ? t('common.buttons.stopBtn')
                                    : t('common.buttons.launchBtn')}
                            </Button>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    )
}